var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.post.allowComments)?_c('div',{staticClass:"search-post-footer"},[_vm._v("\n  "+_vm._s(_vm.$tc('label.number_of_comments', _vm.post.commentCount))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }